import { t } from '@/features/i18n/utils';
import { BidBreadcrumbs } from '@/features/bids/components/bid-breadcrumbs';
import { createFileRoute } from '@tanstack/react-router';
import { BreadcrumbLink, BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Icon } from '@/ui/components/icon';
import { FolderIcon } from '@hugeicons-pro/core-stroke-rounded';
import { Header, HeaderBackButton, HeaderChatButton } from '@/ui/components/header';
import {
  FilesDetailPageBreadcrumbPage,
  FilesDetailPage,
} from '@/features/documents/components/files-page/files-detail-page';
import { documentVersionsQuery } from '@/features/documents/queries';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/files/$documentId',
)({
  component: RouteComponent,
  loader: ({ context, params }) =>
    context.queryClient.query({ ...documentVersionsQuery(params.documentId), staleTime: 'static' }),
});

function RouteComponent() {
  const { projectId, workspaceId, bidId, documentId } = Route.useParams();

  return (
    <>
      <Header>
        <HeaderBackButton />
        <BidBreadcrumbs>
          <BreadcrumbLink
            to="/project/$projectId/workspaces/$workspaceId/bids/$bidId/files"
            params={{ projectId, workspaceId, bidId }}
          >
            <Icon icon={FolderIcon} />
            {t({ en: 'Files', nb: 'Filer' })}
          </BreadcrumbLink>
          <BreadcrumbPage>
            <FilesDetailPageBreadcrumbPage documentId={documentId} />
          </BreadcrumbPage>
        </BidBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <FilesDetailPage documentId={documentId} />
    </>
  );
}
